<template>
  <div>
    <v-card max-width="344" class="mx-auto">
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>Email address verification</span>
      </v-card-title>
      <v-card-text>{{ verificationResultMessage }}</v-card-text>
      <v-card-actions>
        <v-btn flat>Resend</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="okButtonClick">OK</v-btn>
      </v-card-actions>
    </v-card>
    <ErrorDialog
      v-if="$store.state.errors.length > 0"
      :showDialog="$store.state.errors.length > 0"
      :errors="$store.state.errors"
      @clickedOk="onClickOkErrorDialog"
    ></ErrorDialog>
  </div>
</template>

<script>
import ErrorDialog from '../components/ErrorDialog'
export default {
  name: 'EmailVerified',
  components: {
    ErrorDialog
  },
  data: () => ({}),
  methods: {
    onClickOkErrorDialog: function() {},
    okButtonClick: function() {
      if (this.verificationResultMessage) {
        this.$router.push('/login').catch(err => {})
      } else {
        this.$router.push('/').catch(err => {})
      }
    }
  },
  computed: {
    verificationResultMessage() {
      if (this.$store.state.AuthStore.emailAddressVerificationStatus) {
        return (
          'Email address ' +
          this.$store.state.AuthStore.emailAddressVerificationStatus.email +
          ' successfully verified, please login now'
        )
      } else {
        return 'Email address is not verified, please try again or resend the verification code.'
      }
    }
  },
  created: function() {
    this.$store.dispatch(
      'AuthStore/verifyEmailAddressCode',
      this.$route.query['token']
    )
  }
}
</script>
<style scoped></style>
